import { render, staticRenderFns } from "./ExistingPropertyEncumbered.vue?vue&type=template&id=21af879c"
import script from "./ExistingPropertyEncumbered.vue?vue&type=script&lang=js"
export * from "./ExistingPropertyEncumbered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports